<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <!-- Accounts Columns -->
    <div
      class="modal fade"
      id="columns-visible"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
      >
        <div class="modal-content">
          <div class="modal-body">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>

            <div class="text-center">
              <h4 class="mb-2">{{ $t("control.columns") }}</h4>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="id"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-grid-pattern"></i>
                        <span class="custom-option-title"> ID </span>
                      </span>
                      <input
                        v-model="columns.id.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="id"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Serial"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-codesandbox"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.serial_number")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.serial_number.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="Serial"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="firstname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-user"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.first_name")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.first_name.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        id="firstname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lastname"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-user"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.last_name")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.last_name.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        id="lastname"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="username"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-at"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.username")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.username.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="username"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Password"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-key"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.password")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.password.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        id="Password"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="mobileNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-phone-call"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.phone")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.phone.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        id="mobileNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="lineNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-device-landline-phone"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.phone_line")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.phone_line.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="lineNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="portNumber"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-network"></i>
                        <span class="custom-option-title">{{
                          this.$store.getters.settings.center == 1
                            ? "رقم البوابة"
                            : $t("accounts.address")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.address.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="portNumber"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Notes"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-note"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.notes")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.notes.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="Notes"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Profile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-databricks"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.profile")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.profile.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="Profile"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="next_profile"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-brand-databricks"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.next_profile")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.next_profile.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="next_profile"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ip"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-current-location"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.connected_ip_address")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.ip_address.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="ip"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="expirationDate"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-calendar-exclamation"></i>
                        <span class="custom-option-title">
                          {{ $t("accounts.expires_at") }}
                        </span>
                      </span>
                      <input
                        v-model="columns.expires_at.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="expirationDate"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ASessions"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-flag-question"></i>
                        <span class="custom-option-title">
                          {{ $t("accounts.sessions") }}
                        </span>
                      </span>
                      <input
                        v-model="columns.allowed_sessions.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="ASessions"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="ARenew"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-repeat"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.auto_renew")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.auto_renew.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="ARenew"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Quota"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-package"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.used_quota")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.remaining_quota_mb.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="Quota"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="QuotaMB"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-package"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.used_quota_value")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.used_quota_mb.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="QuotaMB"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Status"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-playstation-circle"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.status")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.active.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="Status"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Connection"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-share"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.connection")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.online.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="Connection"
                      />
                    </label>
                  </div>
                </div>
                <div
                  v-if="hasPrivilege('accounting_view_account_debts')"
                  class="col-xxl-3 col-md-4 col-6  mb-5"
                >
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Debts"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-moneybag"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.debts")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.debt.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="Debts"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Mac"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-password-mobile-phone"></i>
                        <span class="custom-option-title">
                          {{ $t("accounts.mac_address") }}</span
                        >
                      </span>
                      <input
                        v-model="columns.mac_address.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="Mac"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="LTOnline"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-live-photo"></i>
                        <span class="custom-option-title">
                          {{ $t("accounts.last_seen") }}</span
                        >
                      </span>
                      <input
                        v-model="columns.last_seen.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="LTOnline"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6  mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Bill"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-receipt"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.paid_at")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.paid_at.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="Bill"
                      />
                    </label>
                  </div>
                </div>
                <div
                  class="col-xxl-3 col-md-4 col-6 mb-5"
                  v-if="user.type !== 'reseller'"
                >
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="reseller"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-calendar-plus"></i>
                        <span class="custom-option-title">{{
                          $t("accounts.reseller")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.reseller_id.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="reseller"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-xxl-3 col-md-4 col-6 mb-5">
                  <div class="form-check custom-option custom-option-icon">
                    <label
                      class="form-check-label custom-option-content"
                      for="Creation"
                    >
                      <span class="custom-option-body">
                        <i class="ti ti-calendar-plus"></i>
                        <span class="custom-option-title">{{
                          $t("control.created_at")
                        }}</span>
                      </span>
                      <input
                        v-model="columns.created_at.enabled"
                        @change="updateColumns"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="Creation"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //Accounts Columns -->
    <accountsAdd
      @updated="
        showAddAccount = false;
        applyFilters();
      "
      v-if="hasPrivilege('accounts_edit_accounts') && showAddAccount"
    />
    <profileAdd
      v-if="showAddProfile && hasPrivilege('profiles_edit_profiles')"
      :visible="showAddProfile"
      @updated="
        $router.push({ query: {} });
        applyFilters();
      "
    />

    <!-- //Accounts Details -->
    <transition name="fade">
      <renewAccountProfile
        v-if="showRenew"
        :visible="showRenew"
        :selected-account="selectedData"
        @updated="successRenew"
        @hide="showRenew = false"
      />
    </transition>

    <!-- Invoice List Widget -->

    <!-- <div class="card mb-6">
      <div class="card-widget-separator-wrapper">
        <div class="card-body card-widget-separator">
          <div class="row gy-4 gy-sm-1">
            <div class="col-sm-6 col-lg-3 text-primary">
              <div
                class="d-flex justify-content-between align-items-center card-widget-1 border-end pb-4 pb-sm-0"
              >
                <div>
                  <h4
                    class="mb-0"
                    v-if="accounts_stats.total_accounts !== null"
                  >
                    {{ accounts_stats.total_accounts }}
                  </h4>
                  <p class="mb-0">
                    {{ $t("dashboard.statistics.total_accounts") }}
                  </p>
                </div>
                <div class="avatar me-sm-6">
                  <span
                    class="avatar-initial rounded bg-label-secondary text-heading"
                  >
                    <i class="ti ti-user ti-26px text-primary"></i>
                  </span>
                </div>
              </div>
              <hr class="d-none d-sm-block d-lg-none me-6" />
            </div>
            <div class="col-sm-6 col-lg-3 text-success">
              <div
                class="d-flex justify-content-between align-items-center card-widget-2 border-end pb-4 pb-sm-0"
              >
                <div>
                  <h4
                    class="mb-0"
                    v-if="accounts_stats.online_accounts !== null"
                  >
                    {{ accounts_stats.online_accounts }}
                  </h4>
                  <p class="mb-0">
                    {{ $t("dashboard.statistics.online_accounts") }}
                  </p>
                </div>
                <div class="avatar me-lg-6">
                  <span
                    class="avatar-initial rounded bg-label-secondary text-heading"
                  >
                    <i class="ti ti-user-check ti-26px text-success"></i>
                  </span>
                </div>
              </div>
              <hr class="d-none d-sm-block d-lg-none" />
            </div>
            <div class="col-sm-6 col-lg-3 text-warning">
              <div
                class="d-flex justify-content-between align-items-center border-end pb-4 pb-sm-0 card-widget-3"
              >
                <div>
                  <h4
                    class="mb-0"
                    v-if="accounts_stats.expiring_accounts !== null"
                  >
                    {{ accounts_stats.expiring_accounts }}
                  </h4>
                  <p class="mb-0">
                    {{ $t("dashboard.statistics.expiring_accounts") }}
                  </p>
                </div>
                <div class="avatar me-sm-6">
                  <span
                    class="avatar-initial rounded bg-label-secondary text-heading"
                  >
                    <i class="ti ti-alert-octagon text-warning ti-26px"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-3 text-danger">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h4
                    class="mb-0"
                    v-if="accounts_stats.expired_accounts !== null"
                  >
                    {{ accounts_stats.expired_accounts }}
                  </h4>
                  <p class="mb-0">
                    {{ $t("dashboard.statistics.expired_accounts") }}
                  </p>
                </div>
                <div class="avatar">
                  <span
                    class="avatar-initial rounded bg-label-secondary text-heading"
                  >
                    <i class="ti ti-user-x ti-26px text-danger"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Invoice List Table -->
    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <!-- <div class="row mx-1" bis_skin_checked="1">
            <div
              class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start gap-2 mt-6 mt-md-0 mt-lg-0 mt-xl-0 mt-xxl-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    v-if="hasPrivilege('accounts_edit_accounts')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    class="btn btn-primary waves-effect waves-light"
                    tabindex="0"
                    @click.prevent="openAddAccountDialog"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{ $t("accounts.add_account") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-8 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-4  mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('accounts_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="
                          export_csv('accounts_table', 'accounts')
                        "
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="
                          export_pdf('accounts_table', 'accounts')
                        "
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>

              <div
                id="DataTables_Table_0_filter"
                class="dataTables_filter"
                bis_skin_checked="1"
                v-if="hasPrivilege('accounts_view_search_accounts')"
              >
                <label>
                  <input
                    type="search"
                    class="form-control"
                    @change="applyFilters"
                    v-model="filters.search_query"
                    :placeholder="`${$t('control.search')}`"
                    aria-controls="DataTables_Table_0"
                  />
                </label>
              </div>
            </div>
          </div> -->

          <div class="row mx-1 mt-2" bis_skin_checked="1">
            <div
              class="col-12 col-lg-7 d-flex align-items-center justify-content-start flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    v-if="hasPrivilege('accounts_edit_accounts')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    class="btn btn-primary waves-effect waves-light"
                    tabindex="0"
                    @click.prevent="openAddAccountDialog"
                    :class="{
                      disabled_ssr: !this.$store.getters.settings.license
                        .active,
                    }"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{ $t("accounts.add_account") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dataTables_length"
                id="DataTables_Table_0_length"
                bis_skin_checked="1"
              >
                <label v-if="hasPrivilege('accounts_view_search_accounts')"
                  >{{ $t("control.show") }}
                  <select
                    v-model="filters.rows"
                    @change="applyFilters"
                    name="DataTables_Table_0_length"
                    aria-controls="DataTables_Table_0"
                    class="form-select"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="9999999">{{
                      $t("control.rows_all")
                    }}</option>
                  </select>
                </label>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div class="btn-group" id="dropdown-icon-demo">
                  <button
                    v-if="hasPrivilege('reports_print')"
                    :disabled:="!this.$store.getters.settings.license.active"
                    type="button"
                    class="btn btn-info dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-upload ti-xs me-2"></i>
                    {{ $t("control.export") }}
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="print_table('accounts_table')"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-printer me-2"></i
                        >{{ $t("control.print") }}</a
                      >
                    </li>
                    <li>
                      <a
                        @click.prevent="exportCsv()"
                        href="javascript:void(0);"
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file me-2"></i
                        >{{ $t("control.csv") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript:void(0);"
                        @click.prevent="
                          export_pdf('accounts_table', 'accounts')
                        "
                        class="dropdown-item d-flex align-items-center"
                        ><i class="ti ti-file-text me-2"></i
                        >{{ $t("control.pdf") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#columns-visible"
                    class="btn btn-secondary  waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-scan-eye ti-s me-md-2"></i>
                      <span class="d-md-inline-block d-none">{{
                        $t("control.columns_visible")
                      }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-lg-5 d-flex align-items-center justify-content-end flex-column flex-md-row pe-5 gap-2 gap-md-4 mt-n2 mb-6 mb-md-0 mt-md-0"
              bis_skin_checked="1"
            >
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': autoUpdate,
                      'btn-secondary': !autoUpdate,
                    }"
                    @click.prevent="toggleAutoUpdate"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-refresh ti-s me-2"></i>
                      <span class=" ">{{ $t("control.auto_update") }}</span>
                    </span>
                  </button>
                </div>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    :class="{
                      'btn-primary': filters.save,
                      'btn-secondary': !filters.save,
                    }"
                    @click.prevent="toggleSaveFilters"
                    class="btn waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                  >
                    <span>
                      <i class="ti ti-filter-check ti-s me-2"></i>
                      <span class=" ">{{ $t("control.save_filters") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container "
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 540px;"
            >
              <!-- class="dt-scrollableTable table datatables-basic dataTable no-footer table-hover border-top border-bottom dtr-column table-responsive" -->
              <table
                class="dt-scrollableTable table"
                id="accounts_table"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th>
                      <div class="dropdown" v-if="selection_array.length > 1">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li v-if="hasPrivilege('accounts_renew_48')">
                            <button
                              @click="groupRenew48"
                              class="dropdown-item text-success"
                              href="#"
                            >
                              <i class="ti ti-plus me-2"></i
                              >{{ $t("actions.renew_48") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('accounts_renew_72')">
                            <button
                              @click="groupRenew72"
                              class="dropdown-item text-success"
                              href="#"
                            >
                              <i class="ti ti-plus me-2"></i
                              >{{ $t("actions.renew_72") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('accounts_renew_48_free')">
                            <button
                              @click="groupRenew48Free"
                              class="dropdown-item text-success"
                              href="#"
                            >
                              <i class="ti ti-plus me-2"></i
                              >{{ $t("actions.renew_48_free") }}
                            </button>
                          </li>

                          <li
                            v-if="
                              hasPrivilege('accounts_edit_group_expiration')
                            "
                          >
                            <button
                              @click="groupEditExpiration"
                              class="dropdown-item text-primary"
                              href="#"
                            >
                              <i class="ti ti-calendar me-2"></i
                              >{{ $t("actions.edit_expiration") }}
                            </button>
                          </li>

                          <li
                            v-if="hasPrivilege('accounts_edit_gruop_profiles')"
                          >
                            <button
                              @click="groupEditProfile"
                              class="dropdown-item text-primary"
                              href="#"
                            >
                              <i class="ti ti-brand-databricks me-2"></i
                              >{{ $t("actions.edit_profile") }}
                            </button>
                          </li>

                          <li
                            v-if="hasPrivilege('accounts_disconnect_accounts')"
                          >
                            <button
                              @click="groupDisconnect"
                              class="dropdown-item text-warning"
                              href="#"
                            >
                              <i class="ti ti-wifi-off me-2"></i
                              >{{ $t("actions.disconnect") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('accounts_disable_accounts')">
                            <button
                              @click="groupDisable"
                              v-if="
                                selection_array[0] && selection_array[0].enabled
                              "
                              class="dropdown-item text-warning"
                              href="#"
                            >
                              <i class="ti ti-shield-off me-2"></i
                              >{{ $t("actions.disable") }}
                            </button>
                            <button
                              @click="groupEnable"
                              v-if="
                                selection_array[0] &&
                                  !selection_array[0].enabled
                              "
                              class="dropdown-item text-success"
                              href="#"
                            >
                              <i class="ti ti-shield me-2"></i
                              >{{ $t("actions.enable") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('accounts_clear_sessions')">
                            <button
                              @click="groupClear"
                              class="dropdown-item text-warning"
                              href="#"
                            >
                              <i class="ti ti-eraser me-2"></i
                              >{{ $t("accounts.clear_sessions") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('accounts_delete_accounts')">
                            <button
                              @click="groupDelete"
                              class="dropdown-item text-danger"
                              href="#"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <th>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="allSelected"
                        @click="checkAll"
                      />
                    </th>
                    <th class="sorting" v-if="columns.id.enabled">
                      <div class="sortable" @click="sort('id')">
                        #
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.id.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.id.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.serial_number.enabled">
                      <div class="sortable" @click="sort('serial_number')">
                        {{ $t("accounts.serial_number") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.serial_number.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.serial_number.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.first_name.enabled">
                      <div class="sortable" @click="sort('first_name')">
                        {{ $t("accounts.first_name") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.first_name.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.first_name.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.last_name.enabled">
                      <div class="sortable" @click="sort('last_name')">
                        {{ $t("accounts.last_name") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.last_name.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.last_name.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th v-if="columns.username.enabled">
                      <div class="sortable" @click="sort('username')">
                        {{ $t("accounts.username") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.username.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.username.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th v-if="columns.password.enabled">
                      <div class="sortable" @click="sort('password')">
                        {{ $t("accounts.password") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.password.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.password.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.phone.enabled">
                      <div class="sortable" @click="sort('phone')">
                        {{ $t("accounts.phone") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.phone.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.phone.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.phone_line.enabled">
                      <div class="sortable" @click="sort('phone_line')">
                        {{ $t("accounts.phone_line") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.phone_line.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.phone_line.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.address.enabled">
                      <div class="sortable" @click="sort('address')">
                        {{
                          this.$store.getters.settings.center == 1
                            ? "رقم البوابة"
                            : $t("accounts.address")
                        }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.address.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.address.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.notes.enabled">
                      <div class="sortable" @click="sort('notes')">
                        {{ $t("accounts.notes") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.notes.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.notes.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.profile.enabled">
                      {{ $t("accounts.profile") }}
                    </th>
                    <th class="sorting" v-if="columns.next_profile.enabled">
                      {{ $t("accounts.next_profile") }}
                    </th>
                    <th class="sorting" v-if="columns.ip_address.enabled">
                      {{ $t("accounts.connected_ip_address") }}
                      <!-- <div class="sortable" @click="sort('ip_address')">
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up"
                            :class="{
                              'text-black': columns.ip_address.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down"
                            :class="{
                              'text-black': columns.ip_address.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div> -->
                    </th>
                    <th class="sorting" v-if="columns.created_at.enabled">
                      <div class="sortable" @click="sort('created_at')">
                        {{ $t("control.created_at") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.created_at.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.created_at.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.expires_at.enabled">
                      <div class="sortable" @click="sort('expires_at')">
                        {{ $t("accounts.expires_at") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.expires_at.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.expires_at.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.allowed_sessions.enabled">
                      {{ $t("accounts.sessions") }}
                    </th>
                    <th class="sorting" v-if="columns.auto_renew.enabled">
                      {{ $t("accounts.auto_renew") }}
                    </th>
                    <th
                      class="sorting"
                      v-if="columns.remaining_quota_mb.enabled"
                    >
                      {{ $t("accounts.used_quota") }}
                    </th>
                    <th class="sorting" v-if="columns.used_quota_mb.enabled">
                      {{ $t("accounts.used_quota_value") }}
                    </th>
                    <th class="sorting" v-if="columns.active.enabled">
                      {{ $t("accounts.status") }}
                    </th>
                    <th class="sorting" v-if="columns.online.enabled">
                      {{ $t("accounts.connection") }}
                    </th>
                    <th
                      class="sorting"
                      v-if="
                        columns.debt.enabled &&
                          hasPrivilege('accounting_view_account_debts')
                      "
                    >
                      <div class="sortable" @click="sort('debt')">
                        {{ $t("accounts.debts") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.debt.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.debt.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.mac_address.enabled">
                      {{ $t("accounts.mac_address") }}
                    </th>
                    <th class="sorting" v-if="columns.last_seen.enabled">
                      <div class="sortable" @click="sort('last_seen')">
                        {{ $t("accounts.last_seen") }}
                        <div class="sort-arrows">
                          <i
                            class="ti ti-chevron-up arrow-up ti-xs"
                            :class="{
                              'text-black': columns.last_seen.sort == 1,
                            }"
                          ></i>
                          <i
                            class="ti ti-chevron-down arrow-down ti-xs"
                            :class="{
                              'text-black': columns.last_seen.sort == -1,
                            }"
                          ></i>
                        </div>
                      </div>
                    </th>
                    <th class="sorting" v-if="columns.paid_at.enabled">
                      {{ $t("accounts.paid_at") }}
                    </th>
                    <th
                      class="sorting"
                      v-if="
                        columns.reseller_id.enabled && user.type != 'reseller'
                      "
                    >
                      {{ $t("accounts.reseller") }}
                    </th>
                  </tr>
                  <tr v-if="hasPrivilege('accounts_view_search_accounts')">
                    <th></th>
                    <th></th>
                    <th v-if="columns.id.enabled">
                      <input
                        id="id"
                        v-model="filters.id"
                        dir="auto"
                        @change="applyFilters"
                        type="text"
                        class="form-control form-control-sm"
                      />
                    </th>
                    <th
                      v-if="columns.serial_number.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        id="serial_number"
                        v-model="filters.serial_number"
                        dir="auto"
                        @change="applyFilters"
                        type="text"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th
                      v-if="columns.first_name.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        id="first_name"
                        v-model="filters.first_name"
                        dir="auto"
                        @change="applyFilters"
                        type="text"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th
                      v-if="columns.last_name.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        id="last_name"
                        v-model="filters.last_name"
                        dir="auto"
                        @change="applyFilters"
                        type="text"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th
                      v-if="columns.username.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        v-model="filters.username"
                        dir="auto"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th
                      v-if="columns.password.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.phone.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        v-model="filters.phone"
                        dir="auto"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th
                      v-if="columns.phone_line.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        dir="auto"
                        v-model="filters.phone_line"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th
                      v-if="columns.address.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        dir="auto"
                        v-model="filters.address"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th
                      v-if="columns.notes.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        dir="auto"
                        v-model="filters.notes"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th
                      v-if="columns.profile.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        dir="auto"
                        v-model="filters.profile"
                        type="text"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                        @change="applyFilters"
                      />
                    </th>
                    <th
                      v-if="columns.next_profile.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        v-model="filters.next_profile"
                        @change="applyFilters"
                        class="form-select form-select-sm"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="true">{{ $t("control.yes") }}</option>
                        <option value="false">{{ $t("control.no") }}</option>
                      </select>
                    </th>
                    <th
                      v-if="columns.ip_address.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        dir="auto"
                        v-model="filters.ip_address"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th
                      v-if="columns.created_at.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    ></th>
                    <th
                      v-if="columns.expires_at.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        placeholder="YYYY-MM-DD"
                        dir="auto"
                        v-model="filters.expires_at"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        id="ahmad-date"
                      />
                    </th>
                    <th
                      v-if="columns.allowed_sessions.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <input
                        type="text"
                        v-model="filters.allowed_sessions"
                        @change="applyFilters"
                        class="form-control form-control-sm"
                        :placeholder="`${$t('control.search')}`"
                      />
                    </th>
                    <th
                      v-if="columns.auto_renew.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        class="form-select w-100 form-select-sm"
                        data-style="btn-default"
                        v-model="filters.auto_renew"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="0">{{ $t("control.no") }}</option>
                        <option value="1">{{ $t("control.yes") }}</option>
                      </select>
                    </th>
                    <th v-if="columns.remaining_quota_mb.enabled"></th>
                    <th v-if="columns.used_quota_mb.enabled"></th>
                    <th
                      v-if="columns.active.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        class="form-select w-100 form-select-sm"
                        data-style="btn-default"
                        v-model="filters.active"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="active">{{
                          $t("control.active")
                        }}</option>
                        <option value="expired">{{
                          $t("control.expired")
                        }}</option>
                        <option value="expiring">{{
                          $t("control.expiring")
                        }}</option>
                        <option value="expiration_profile">{{
                          $t("control.expiration_profile")
                        }}</option>
                        <option value="disabled">{{
                          $t("control.disabled")
                        }}</option>
                      </select>
                    </th>
                    <th
                      v-if="columns.online.enabled"
                      rowspan="1"
                      colspan="1"
                      style="border-left: none;"
                    >
                      <select
                        class="form-select w-100 form-select-sm"
                        data-style="btn-default"
                        v-model="filters.online"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option value="online">{{
                          $t("control.online")
                        }}</option>
                        <option value="offline">{{
                          $t("control.offline")
                        }}</option>
                      </select>
                    </th>
                    <th
                      v-if="
                        columns.debt.enabled &&
                          hasPrivilege('accounting_view_account_debts')
                      "
                    ></th>
                    <th v-if="columns.mac_address.enabled"></th>
                    <th v-if="columns.last_seen.enabled"></th>
                    <th v-if="columns.paid_at.enabled"></th>
                    <th
                      v-if="
                        columns.reseller_id.enabled && user.type != 'reseller'
                      "
                    >
                      <select
                        class="form-select w-100 form-select-sm"
                        data-style="btn-default"
                        v-model="filters.reseller_id"
                        @change="applyFilters"
                      >
                        <option value="">{{ $t("control.all") }}</option>
                        <option
                          v-for="reseller in resellers"
                          v-bind:key="reseller.id"
                          :value="reseller.id"
                        >
                          {{ reseller.email }}
                        </option>
                      </select>
                    </th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="table-border-bottom-0 ">
                  <tr v-for="(item, index) in 10" :key="index">
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th>
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                    <th
                      v-for="(item, index) in Object.values(columns).filter(
                        (col) => col?.enabled === true,
                      ).length"
                      :key="index"
                    >
                      <p class="placeholder-glow">
                        <span class="placeholder col-12"></span>
                      </p>
                    </th>
                  </tr>
                </tbody>
                <tbody class="table-border-bottom-0 " v-if="!loading">
                  <tr v-for="(account, index) in dataList" :key="account.id">
                    <th>
                      <div
                        class="dropdown relative"
                        v-if="selection_array.length <= 1"
                      >
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul
                          class="dropdown-menu absolute"
                          :class="{
                            disabled_ssr: !this.$store.getters.settings.license
                              .active,
                          }"
                        >
                          <li
                            v-if="hasPrivilege('accounts_view_index_accounts')"
                          >
                            <button
                              class="dropdown-item text-primary"
                              @click.prevent="
                                $router.push(`/accounts/${account.id}`)
                              "
                            >
                              <i class="ti ti-eye me-2"></i
                              >{{ $t("actions.view") }}
                            </button>
                          </li>
                          <li
                            v-if="hasPrivilege('accounts_view_accounts_quota')"
                          >
                            <button
                              class="dropdown-item text-primary"
                              @click.prevent="
                                $router.push(
                                  `/sessions?username=${account.username}`,
                                )
                              "
                            >
                              <i class="ti ti-device-laptop me-2"></i
                              >{{ $t("actions.view_sessions") }}
                            </button>
                          </li>
                          <li
                            v-if="
                              hasPrivilege('accounts_edit_accounts') ||
                                hasPrivilege('accounting_pay_bill') ||
                                hasPrivilege('accounts_renew_accounts')
                            "
                          >
                            <button
                              @click="renewData(account)"
                              class="dropdown-item text-success"
                            >
                              <i class="ti ti-wand me-2"></i
                              >{{ $t("actions.renew") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('accounts_renew_48')">
                            <button
                              @click="renewTemp(account)"
                              class="dropdown-item text-success"
                            >
                              <i class="ti ti-plus me-2"></i
                              >{{ $t("actions.renew_48") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('accounts_renew_72')">
                            <button
                              @click="renew72(account)"
                              class="dropdown-item text-success"
                            >
                              <i class="ti ti-plus me-2"></i
                              >{{ $t("actions.renew_72") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('accounts_renew_48_free')">
                            <button
                              @click="renewTempFree(account)"
                              class="dropdown-item text-success"
                            >
                              <i class="ti ti-plus me-2"></i
                              >{{ $t("actions.renew_48_free") }}
                            </button>
                          </li>

                          <li
                            v-if="hasPrivilege('accounts_disconnect_accounts')"
                          >
                            <button
                              @click="disconnectData(account)"
                              class="dropdown-item text-warning"
                            >
                              <i class="ti ti-wifi-off me-2"></i
                              >{{ $t("actions.disconnect") }}
                            </button>
                          </li>
                          <li
                            v-if="
                              account.enabled &&
                                hasPrivilege('accounts_disable_accounts')
                            "
                          >
                            <button
                              @click="disableData(account)"
                              class="dropdown-item text-warning"
                            >
                              <i class="ti ti-shield-off me-2"></i
                              >{{ $t("actions.disable") }}
                            </button>
                          </li>
                          <li
                            v-if="
                              !account.enabled &&
                                hasPrivilege('accounts_disable_accounts')
                            "
                          >
                            <button
                              @click="enableData(account)"
                              class="dropdown-item text-success"
                            >
                              <i class="ti ti-shield me-2"></i
                              >{{ $t("actions.enable") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('accounts_clear_sessions')">
                            <button
                              @click="clearData(account)"
                              class="dropdown-item text-warning"
                            >
                              <i class="ti ti-eraser me-2"></i
                              >{{ $t("accounts.clear_sessions") }}
                            </button>
                          </li>
                          <li v-if="hasPrivilege('accounts_delete_accounts')">
                            <button
                              @click="deleteData(account)"
                              class="dropdown-item text-danger"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </th>
                    <th scope="row">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="account.selected"
                        @click="selectData(account)"
                      />
                    </th>

                    <th v-if="columns.id.enabled" scope="row">
                      <a
                        :href="`accounts/${account.id}`"
                        @click.prevent="$router.push(`/accounts/${account.id}`)"
                        >{{ account.id }}</a
                      >
                    </th>
                    <td v-if="columns.serial_number.enabled">
                      {{ account.serial_number }}
                    </td>
                    <td v-if="columns.first_name.enabled">
                      {{ account.first_name }}
                    </td>
                    <td v-if="columns.last_name.enabled">
                      {{ account.last_name }}
                    </td>
                    <td v-if="columns.username.enabled" dir="ltr">
                      <a
                        class="btn btn-link"
                        :href="`accounts/${account.id}`"
                        @click.prevent="$router.push(`/accounts/${account.id}`)"
                        dir="ltr"
                        >{{ account.username }}</a
                      >
                    </td>
                    <td v-if="columns.password.enabled">
                      {{ account.password }}
                    </td>
                    <td v-if="columns.phone.enabled" dir="ltr">
                      {{ account.phone }}
                    </td>
                    <td v-if="columns.phone_line.enabled">
                      {{ account.phone_line }}
                    </td>
                    <td v-if="columns.address.enabled">
                      {{ account.address }}
                    </td>
                    <td v-if="columns.notes.enabled">{{ account.notes }}</td>
                    <td v-if="columns.profile.enabled">
                      <a
                        v-if="hasPrivilege('profiles_edit_profiles')"
                        :href="`profiles?profile_id=${account.profile.id}`"
                        @click.prevent="openAddProfileDialog(account.profile)"
                        dir="ltr"
                        >{{ account.profile.name }}</a
                      >
                      <div v-else dir="ltr">
                        {{ account.profile.name }}
                      </div>
                    </td>
                    <td v-if="columns.next_profile.enabled">
                      {{ account.next_profile_name }}
                    </td>
                    <td v-if="columns.ip_address.enabled">
                      <div v-if="account.active_sessions.length > 0">
                        <a
                          v-for="(session, index) in account.active_sessions"
                          :key="index"
                          :href="`http://${session.framedipaddress}`"
                          target="_blank"
                          @click.prevent="
                            openTab(`http://${session.framedipaddress}`)
                          "
                        >
                          {{ session.framedipaddress }}
                        </a>
                      </div>
                    </td>
                    <td v-if="columns.created_at.enabled">
                      {{ this.formatDateHours(account.created_at) }}
                    </td>
                    <td v-if="columns.expires_at.enabled">
                      <div v-if="account.profile.has_expiration">
                        {{ this.formatDate(account.expires_at) }}
                        <span
                          class="font-bold text-blue-700 h-4 w-4"
                          v-if="account.wait_days"
                        >
                          {{ "+" + account.wait_days }}
                        </span>
                      </div>
                      <div v-else>{{ $t("control.unlimited") }}</div>
                    </td>
                    <td v-if="columns.allowed_sessions.enabled">
                      {{ account.allowed_sessions }}
                    </td>
                    <td v-if="columns.auto_renew.enabled">
                      {{ account.auto_renew }}
                    </td>
                    <td v-if="columns.remaining_quota_mb.enabled">
                      <div
                        v-if="account.profile.traffic_limited"
                        class="progress"
                        style="height: 25px;width: 180px;"
                      >
                        <div
                          v-if="hasPrivilege('accounts_view_accounts_quota')"
                          class="progress-bar"
                          role="progressbar"
                          :style="{
                            width: `${parseFloat(
                              (account.used_quota_mb * 100) /
                                account.allowed_quota_mb,
                            ).toFixed(0)}%`,
                          }"
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {{
                            parseFloat(
                              (account.used_quota_mb * 100) /
                                account.allowed_quota_mb,
                            ).toFixed(0)
                          }}%
                        </div>
                      </div>
                      <span v-else>
                        <i class="ti ti-infinity ti-s me-2"></i>
                        <span class=" ">{{ $t("control.unlimited") }}</span>
                      </span>
                    </td>
                    <td v-if="columns.used_quota_mb.enabled">
                      <span
                        class="badge bg-label-info mb-2 me-1"
                        v-if="account.used_quota_mb !== ''"
                        >{{
                          account.used_quota_mb >= 1024
                            ? parseFloat(account.used_quota_mb / 1024).toFixed(
                                2,
                              ) + " GB"
                            : account.used_quota_mb + " MB"
                        }}</span
                      >
                    </td>
                    <td v-if="columns.active.enabled">
                      <div
                        class="btn"
                        v-if="hasPrivilege('accounts_view_accounts_status')"
                        :disabled="!this.$store.getters.settings.license.active"
                        @click="renewData(account)"
                      >
                        <span
                          v-if="!account.enabled"
                          class="badge bg-label-danger me-1"
                          >{{ $t("control.disabled") }}</span
                        >
                        <span
                          v-if="account.enabled && account.active"
                          class="badge bg-label-success me-1"
                          >{{ $t("control.enabled") }}</span
                        >
                        <span
                          v-if="
                            !account.active &&
                              account.enabled &&
                              !account.profile.has_expiration_profile
                          "
                          class="badge bg-label-danger me-1"
                          >{{ $t("control.expired") }}</span
                        >
                        <span
                          v-if="
                            !account.active &&
                              account.enabled &&
                              account.profile.has_expiration_profile
                          "
                          class="badge bg-label-warning me-1"
                          >{{ $t("control.expiration_profile") }}</span
                        >
                      </div>
                    </td>
                    <td v-if="columns.online.enabled">
                      <div v-if="hasPrivilege('accounts_view_accounts_status')">
                        <span
                          v-if="account.online"
                          class="badge bg-label-success me-1"
                          >{{ $t("control.online") }}</span
                        >
                        <span v-else class="badge bg-label-danger me-1">{{
                          $t("control.offline")
                        }}</span>
                      </div>
                    </td>
                    <td
                      v-if="
                        columns.debt.enabled &&
                          hasPrivilege('accounting_view_account_debts')
                      "
                    >
                      {{ account.debt + "₺" }}
                    </td>
                    <td v-if="columns.mac_address.enabled">
                      <span
                        v-if="hasPrivilege('accounts_view_accounts_status')"
                        >{{ account.mac_address }}</span
                      >
                    </td>
                    <td v-if="columns.last_seen.enabled">
                      <span
                        v-if="hasPrivilege('accounts_view_accounts_status')"
                        >{{ formatDateHours(account.last_seen) }}</span
                      >
                    </td>
                    <td v-if="columns.paid_at.enabled">
                      {{ formatDateHours(account.paid_at) }}
                    </td>
                    <td
                      v-if="
                        columns.reseller_id.enabled && user.type != 'reseller'
                      "
                    >
                      {{
                        account.reseller_id && resellers.length > 0
                          ? resellers.filter(
                              (reseller) => reseller.id === account.reseller_id,
                            )[0]?.email
                          : ""
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="bill_print_page"
      v-if="selectedBill"
      class="bill-container noScreen"
    >
      <!-- Print button, hidden during printing -->
      <!-- Main bill content -->
      <div class="bill-content">
        <!-- Header with company info -->
        <div class="bill-header text-center">
          <div v-if="settings.print.network_logo" class="flex justify-center">
            <img
              :src="server_url + settings.network_logo"
              style="height: 4rem; width: 4rem;"
            />
          </div>
          <div v-if="settings.print.network_name" class="company-name">
            {{ settings.network_name }}
          </div>
        </div>

        <!-- Profile and billing period -->
        <div class="bill-summary">
          <div class="summary-item">
            <span>{{ $t("bills.invoice.bill_to") }}</span>
            <span
              >{{ selectedBill.account.first_name }}
              {{ selectedBill.account.last_name }}</span
            >
          </div>
          <div v-if="settings.print.address" class="summary-item">
            <span>{{
              this.$store.getters.settings.center == 1
                ? "رقم البوابة"
                : $t("accounts.address")
            }}</span>
            <span>{{ selectedBill.account.address }}</span>
          </div>
          <div v-if="settings.print.phone" class="summary-item">
            <span>{{ $t("accounts.phone") }}</span>
            <span style="direction: ltr;">{{
              selectedBill.account.phone
            }}</span>
          </div>
          <div v-if="settings.print.phone_line" class="summary-item">
            <span>{{ $t("accounts.phone_line") }}</span>
            <span style="direction: ltr;">{{
              selectedBill.account.phone_line
            }}</span>
          </div>
          <div v-if="settings.print.issued_date" class="summary-item">
            <span>{{ $t("bills.invoice.issued_date") }}</span>
            <span>{{ formatDate(selectedBill.created_at) }}</span>
          </div>
          <div v-if="settings.print.account_id" class="summary-item">
            <span>{{ $t("bills.invoice.account_id") }}</span>
            <span>{{ selectedBill.account.id }}</span>
          </div>
          <div v-if="settings.print.bill_id" class="summary-item">
            <span>{{ $t("bills.invoice.bill_id") }}</span>
            <span>{{ selectedBill.id }}</span>
          </div>
          <div v-if="settings.print.slug" class="summary-item">
            <span>{{ $t("bills.slug") }}</span>
            <span>{{ selectedBill.slug }}</span>
          </div>
          <div v-if="settings.print.profile" class="summary-item">
            <span>{{ $t("bills.invoice.profile") }}:</span>
            <span class="font-bold" dir="ltr">{{
              selectedBill.profile.name
            }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.from") }}:</span>
            <span class="font-bold">{{ formatDate(selectedBill.from) }}</span>
          </div>
          <div class="summary-item">
            <span>{{ $t("bills.to") }}:</span>
            <span class="font-bold">{{ formatDate(selectedBill.to) }}</span>
          </div>
        </div>

        <!-- Itemized table -->
        <table class="bill-table">
          <thead>
            <tr>
              <th colspan="2">{{ $t("bills.invoice.description") }}</th>
              <th>{{ $t("bills.invoice.amount") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="2">{{ $t("bills.price") }}</td>
              <td>
                {{ selectedBill.price }}
                <span class="font-bold">{{ settings.currency }}</span>
              </td>
            </tr>
            <tr>
              <td colspan="2">{{ $t("bills.paid") }}</td>
              <td>
                {{ selectedBill.paid }}
                <span class="font-bold">{{ settings.currency }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="2">{{ $t("bills.invoice.remaining") }}</th>
              <th>
                {{ selectedBill.price - selectedBill.paid }}
                <span class="font-bold">{{ settings.currency }}</span>
              </th>
            </tr>
          </tfoot>
        </table>

        <!-- Issued by and signature -->
        <div class="bill-issuer">
          <div>{{ $t("bills.invoice.issued_by") }}:</div>
          <div>{{ user.first_name }} {{ user.last_name }}</div>
          <div>{{ formatDate(selectedBill.created_at) }}</div>
          <img
            v-if="user.signature"
            :src="server_url + user.signature"
            class="signature"
          />
        </div>

        <!-- Notes -->
        <div v-if="selectedBill.notes" class="bill-notes">
          <div>{{ $t("bills.notes") }}:</div>
          <div>{{ selectedBill.notes }}</div>
        </div>

        <!-- Footer -->
        <div class="bill-footer">
          <div>{{ settings.network_name }}</div>
          <div style="direction: ltr;">{{ settings.phone_number }}</div>
          <div>{{ settings.status_url }}</div>
        </div>
      </div>
    </div>
    <!-- <div v-if="selectedBill" id="bill_print_page">
      <div class="grid grid-cols-8 justify-center w-full p-6 text-black">
        <div class="col-span-2 flex flex-col justify-center items-center">
          <img :src="server_url + settings.network_logo" class="h-32" />
          <div class="text-2xl">{{ settings.network_name }}</div>
        </div>
        <div class="col-span-8 h-12"></div>
        <div class="col-span-2 flex flex-col items-start justify-start">
          <div class="font-bold">{{ $t("bills.invoice.bill_to") }}:</div>
          <div>
            {{
              selectedBill.account.first_name +
                " " +
                selectedBill.account.last_name
            }}
          </div>
          <div>
            {{ selectedBill.account.address }}
          </div>
          <div style="direction: ltr;">
            {{ selectedBill.account.phone }}
          </div>
          <div>
            {{ selectedBill.account.phone_line }}
          </div>
        </div>
        <div
          class="col-span-3 col-start-6 flex flex-col items-start justify-start"
        >
          <div class="w-full flex justify-between">
            <div>{{ $t("bills.invoice.issued_date") }}:</div>
            <div>{{ formatDate(selectedBill.created_at) }}</div>
          </div>
          <div class="w-full flex justify-between">
            <div>{{ $t("bills.invoice.account_id") }}:</div>
            <div>{{ selectedBill.account.id }}</div>
          </div>
          <div class="w-full flex justify-between">
            <div>{{ $t("bills.invoice.bill_id") }}:</div>
            <div>{{ selectedBill.id }}</div>
          </div>
          <div class="w-full flex justify-between">
            <div>{{ selectedBill.slug }}</div>
          </div>
        </div>
        <div class="col-span-8 h-6"></div>
        <div
          class="flex flex-col col-span-2 bg-yellow-300 text-black justify-center text-xl border-gray-100 border p-4"
        >
          <div>{{ $t("bills.invoice.profile") }}:</div>
          <div class="font-bold">{{ selectedBill.profile.name }}</div>
        </div>
        <div
          class="flex flex-col col-span-2 bg-yellow-300 text-black justify-center text-xl border-gray-100 border p-4"
        >
          <div>{{ $t("bills.from") }}:</div>
          <div class="font-bold">{{ formatDate(selectedBill.from) }}</div>
        </div>
        <div
          class="flex flex-col col-span-2 bg-yellow-300 text-black justify-center text-xl border-gray-100 border p-4"
        >
          <div>{{ $t("bills.to") }}:</div>
          <div class="font-bold">{{ formatDate(selectedBill.to) }}</div>
        </div>
        <div
          class="flex flex-col col-span-2 bg-gray-800 text-white justify-center text-xl border-gray-100 border p-4"
        >
          <div>{{ $t("bills.price") }}:</div>
          <div class="font-bold font-sans">
            {{ selectedBill.price + settings.currency }}
          </div>
        </div>
        <div class="col-span-8 h-6"></div>

        <div class="col-span-8" style="text-align: end;">
          <table class="w-full">
            <thead class="font-bold border-b-2 border-black">
              <tr>
                <th colspan="2" class="px-2">
                  {{ $t("bills.invoice.description") }}
                </th>
                <th>{{ $t("bills.invoice.amount") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-black border-t border-b">
                <td colspan="2" class="px-2">
                  {{ $t("bills.price") }}
                </td>
                <td>
                  {{ selectedBill.price }}
                  <span class="font-sans font-bold">{{
                    settings.currency
                  }}</span>
                </td>
              </tr>
              <tr class="border-black border-t border-b">
                <td colspan="2" class="px-2">
                  {{ $t("bills.paid") }}
                </td>
                <td>
                  {{ selectedBill.paid }}
                  <span class="font-sans font-bold">{{
                    settings.currency
                  }}</span>
                </td>
              </tr>
            </tbody>
            <tfoot class=" border-t-2 border-black">
              <tr>
                <th colspan="2" class="px-2">
                  {{ $t("bills.invoice.remaining") }}
                </th>
                <th>
                  {{ selectedBill.price - selectedBill.paid }}
                  <span class="font-sans font-bold">{{
                    settings.currency
                  }}</span>
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="col-span-2 col-start-6 mt-12">
          <div>{{ $t("bills.invoice.issued_by") }}:</div>
          <div>{{ user.first_name + " " + user.last_name }}</div>
          <div>
            {{ formatDate(selectedBill.created_at) }}
          </div>
          <img
            v-if="user.signature"
            :src="server_url + user.signature"
            class="h-16 mt-1"
          />
        </div>
        <div
          v-if="selectedBill.notes"
          class="col-span-8 flex items-start flex-col"
        >
          <div>{{ $t("bills.notes") }}:</div>
          <div>{{ selectedBill.notes }}</div>
        </div>
        <div class="col-span-8 w-full border-b border-black mt-12"></div>
        <div style="direction: ltr;" class="col-span-3 flex justify-start">
          {{ settings.phone_number }}
        </div>
        <div class="col-span-2 text-center">{{ settings.network_name }}</div>
        <div class="col-span-3 flex justify-end">
          {{ settings.status_url }}
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import accountsColumns from "../components/modals/accounts-columns.vue";
import accountsAdd from "../components/modals/accounts-add.vue";
import profileAdd from "../components/modals/profile-add.vue";
import accountDetails from "../components/modals/account-details.vue";
import renewAccountProfile from "../components/modals/renew-account-profile.vue";
import {
  export_csv,
  export_pdf,
  hasPrivilege,
  print_element,
  print_table,
} from "../global_constants.js";
import { mapGetters } from "vuex";
import axios from "axios";
import { notify } from "@kyvg/vue3-notification";
import { nextTick } from "vue";
export default {
  components: {
    accountsColumns,
    accountsAdd,
    accountDetails,
    renewAccountProfile,
    profileAdd,
  },
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  data() {
    return {
      dataList: null,
      meta: {
        last_page: 0,
      },
      selectedData: { profile: null },
      showDetails: false,
      showProfileDetails: false,
      showDelete: false,
      showDeleteAll: false,
      showDisable: false,
      showEnable: false,
      showDisconnect: false,
      showClear: false,
      showContext: false,
      showRenew: false,
      showNotification: false,
      showEditExpirationAll: false,
      showMoney: false,
      showClearAll: false,
      showTempSpeed: false,
      showAddAccount: false,
      showAddProfile: false,
      selectedBill: null,
      loading: true,
      loading_overlay: false,
      showFilters: false,
      fullList: false,
      filters: {
        rows: 10,
        page: 1,
        save: false,
        sort_col: null,
        sort_dir: null,
        first_name: "",
        last_name: "",
        username: "",
        phone: "",
        phone_line: "",
        address: "",
        notes: "",
        profile: "",
        next_profile: "",
        ip_address: "",
        expires_at: "",
        allowed_sessions: "",
        auto_renew: "",
        remaining_quota_mb: "",
        active: "",
        online: "",
        mac_address: "",
        id: "",
        serial_number: "",
        reseller_id: "",
        search_query: null,
        search_query_full: null,
      },
      checkedBox: true,
      allSelected: false,
      showColumnsSelect: false,
      columns: {
        id: {
          enabled: false,
          sort: false,
        },
        serial_number: {
          enabled: false,
          sort: false,
        },
        first_name: {
          enabled: false,
          sort: false,
        },
        last_name: {
          enabled: false,
          sort: false,
        },
        username: {
          enabled: true,
          sort: false,
        },
        password: {
          enabled: true,
          sort: false,
        },
        phone: { enabled: false, sort: false },
        phone_line: {
          enabled: false,
          sort: false,
        },
        address: {
          enabled: false,
          sort: false,
        },
        notes: {
          enabled: false,
          sort: false,
        },
        profile: {
          enabled: true,
          sort: false,
        },
        next_profile: {
          enabled: false,
          sort: false,
        },
        ip_address: {
          enabled: false,
          sort: false,
        },
        expires_at: {
          enabled: true,
          sort: false,
        },
        allowed_sessions: {
          enabled: false,
          sort: false,
        },
        auto_renew: {
          enabled: false,
          sort: false,
        },
        remaining_quota_mb: {
          enabled: true,
          sort: false,
        },
        used_quota_mb: {
          enabled: false,
          sort: false,
        },
        active: {
          enabled: true,
          sort: false,
        },
        online: {
          enabled: true,
          sort: false,
        },
        debt: {
          enabled: true,
          sort: false,
        },
        mac_address: {
          enabled: true,
          sort: false,
        },
        last_seen: {
          enabled: false,
          sort: false,
        },
        paid_at: {
          enabled: false,
          sort: false,
        },
        reseller_id: {
          enabled: false,
          sort: false,
        },
        created_at: {
          enabled: false,
          sort: false,
        },
      },
      autoUpdate: false,
      selection_array: [],
      sort_col: null,
      sort_dir: null,
      debounce: null,
      debounce_counter: 0,
      resellers: [],
      in_debt: false,
      pdfOptions: {
        margin: 5,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: { scale: 1, dpi: 96, letterRendering: true },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "p",
        },
      },
      exportFilename: "accounts.pdf",
      accounts_stats: {
        total_accounts: 0,
        online_accounts: 0,
        disabled_accounts: 0,
        expiring_accounts: 0,
        expired_accounts: 0,
      },
      server_url: localStorage.getItem("server"),
    };
  },
  async created() {
    this.prepareColumns();
    this.prepareFilters();

    if (this.$route.query.type) {
      switch (this.$route.query.type) {
        case "online":
          this.filters.online = "online";
          break;
        case "expired":
          this.filters.active = "expired";
          break;
        case "disabled":
          this.filters.active = "disabled";
          break;
        case "expiring":
          this.filters.active = "expiring";
          break;
        case "expiration_profile":
          this.filters.active = "expiration_profile";
          break;
        case "in_debt":
          this.in_debt = true;
      }
    }
    if (this.$route.query.useranme) {
      this.filters.username = this.$route.query.useranme;
      this.columns.enabled = true;
    }
    if (this.$route.query.search_query) {
      this.filters.search_query_full = this.$route.query.search_query;
    }
    await this.applyFilters();

    // this.$swal("Hello Vue world!!!", {
    //   position: "top-end",
    //   icon: "success",
    //   title: "Success",
    //   showConfirmationButton: false,
    //   confirmButtonColor: "#41b882",
    //   timer: 1500,
    // });
    console.log(this.user);

    if (this.user.type != "reseller") {
      await this.fetchResellers();
    }
    await this.$nextTick();
  },
  watch: {
    "$route.query.search_query_full"(value) {
      this.filters.search_query_full = value;
      this.applyFilters();
    },
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetchAccounts() {
      if (this.filters.rows > 0 || this.filters.page > 0) {
        this.fetchDataPortion(this.filters.rows, this.filters.page);
        this.selection_array = [];
        return;
      }
      const response = await axios.get("accounts");
      this.dataList = response.data.data;
      this.meta = response.data.meta;
      this.loading = false;
    },
    async fetchStats() {
      const response = await axios.get(`/accounts/stats`);
      if (response.status == 200) {
        this.accounts_stats = response.data.data;
      }
    },
    async openAddAccountDialog() {
      this.showAddAccount = true;
      await this.$nextTick();
      var modalElement = document.getElementById("add-account");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalInstance.show();
    },
    prepareFilters() {
      var filters = localStorage.getItem("accounts_filters");
      if (filters != null) {
        filters = JSON.parse(filters);
        if (filters.save) this.filters = filters;
        else this.filters.rows = filters.rows;
        if (this.filters.sort_col) {
          this.sort_col = this.filters.sort_col;
          if (this.filters.sort_dir) {
            this.sort_dir = this.filters.sort_dir;
            this.columns[this.sort_col].sort = this.sort_dir == "ASC" ? 1 : -1;
          }
        }
      }
    },
    prepareColumns() {
      var cols0 = localStorage.getItem("accounts2_columns");
      if (cols0 != null) {
        cols0 = JSON.parse(cols0);
        this.columns = {
          id: {
            enabled: cols0[0].enabled,
            sort: false,
          },
          serial_number: {
            enabled: cols0[1].enabled,
            sort: false,
          },
          first_name: {
            enabled: cols0[2].enabled,
            sort: false,
          },
          last_name: {
            enabled: cols0[3].enabled,
            sort: false,
          },
          username: {
            enabled: cols0[4].enabled,
            sort: false,
          },
          password: {
            enabled: cols0[5].enabled,
            sort: false,
          },
          phone: { enabled: cols0[6].enabled, sort: false },
          phone_line: {
            enabled: cols0[7].enabled,
            sort: false,
          },
          address: {
            enabled: cols0[8].enabled,
            sort: false,
          },
          notes: {
            enabled: cols0[9].enabled,
            sort: false,
          },
          profile: {
            enabled: cols0[10].enabled,
            sort: false,
          },
          ip_address: {
            enabled: cols0[11].enabled,
            sort: false,
          },
          expires_at: {
            enabled: cols0[12].enabled,
            sort: false,
          },
          allowed_sessions: {
            enabled: cols0[13].enabled,
            sort: false,
          },
          auto_renew: {
            enabled: cols0[14].enabled,
            sort: false,
          },
          remaining_quota_mb: {
            enabled: cols0[15].enabled,
            sort: false,
          },
          used_quota_mb: {
            enabled: cols0[16].enabled,
            sort: false,
          },
          active: {
            enabled: cols0[17].enabled,
            sort: false,
          },
          online: {
            enabled: cols0[18].enabled,
            sort: false,
          },
          debt: {
            enabled: cols0[19].enabled,
            sort: false,
          },
          mac_address: {
            enabled: cols0[20].enabled,
            sort: false,
          },
          last_seen: {
            enabled: cols0[21].enabled,
            sort: false,
          },
          paid_at: {
            enabled: cols0[22].enabled,
            sort: false,
          },
          reseller_id: {
            enabled: cols0[23].enabled,
            sort: false,
          },
          created_at: {
            enabled: cols0[24] != null ? cols0[24].enabled : false,
            sort: false,
          },
          next_profile: {
            enabled: cols0[25] != null ? cols0[25].enabled : false,
            sort: false,
          },
        };
        return;
      }

      var cols = localStorage.getItem("accounts_columns");
      if (cols != null) {
        cols = JSON.parse(cols);
        this.columns = {
          first_name: {
            enabled: cols[0].enabled,
            sort: false,
          },
          last_name: {
            enabled: cols[1].enabled,
            sort: false,
          },
          username: {
            enabled: cols[2].enabled,
            sort: false,
          },
          password: {
            enabled: cols[3].enabled,
            sort: false,
          },
          phone: { enabled: cols[4].enabled },
          phone_line: {
            enabled: cols[5].enabled,
          },
          address: {
            enabled: cols[6].enabled,
          },
          notes: {
            enabled: cols[7].enabled,
          },
          profile: {
            enabled: cols[8].enabled,
            sort: false,
          },
          ip_address: {
            enabled: cols[9].enabled,
            sort: false,
          },
          expires_at: {
            enabled: cols[10].enabled,
            sort: false,
          },
          allowed_sessions: {
            enabled: cols[11].enabled,
            sort: false,
          },
          auto_renew: {
            enabled: cols[12].enabled,
            sort: false,
          },
          remaining_quota_mb: {
            enabled: cols[13].enabled,
            sort: false,
          },
          used_quota_mb: {
            enabled: cols[14].enabled ? cols[14].enabled : false,
            sort: false,
          },
          active: {
            enabled: cols[15] != null ? cols[15].enabled : true,
            sort: false,
          },
          online: {
            enabled: cols[16] != null ? cols[16].enabled : true,
            sort: false,
          },
          debt: {
            enabled: cols[17] != null ? cols[17].enabled : true,
            sort: false,
          },
          mac_address: {
            enabled: cols[18] != null ? cols[18].enabled : true,
            sort: false,
          },
          last_seen: {
            enabled: cols[19] != null ? cols[19].enabled : false,
            sort: false,
          },
          paid_at: {
            enabled: cols[20] != null ? cols[20].enabled : false,
            sort: false,
          },
          created_at: {
            enabled: cols[21] != null ? cols[21].enabled : false,
            sort: false,
          },
          id: {
            enabled: cols[22] != null ? cols[22].enabled : false,
            sort: false,
          },
          serial_number: {
            enabled: cols[23] != null ? cols[23].enabled : false,
            sort: false,
          },
          reseller_id: {
            enabled: cols[24] != null ? cols[24].enabled : false,
            sort: false,
          },
          next_profile: {
            enabled: cols[25] != null ? cols[25].enabled : false,
            sort: false,
          },
        };
      }
    },
    sort(param) {
      this.sort_col = param;
      if (this.columns[param].sort == false) {
        this.sort_dir = "ASC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false; // the value of the current key.
        });
        this.columns[param].sort = 1;
      } else if (this.columns[param].sort == 1) {
        this.sort_dir = "DESC";
        Object.entries(this.columns).forEach(([key, val]) => {
          val.sort = false; // the value of the current key.
        });
        this.columns[param].sort = -1;
      } else {
        this.sort_col = null;
        this.sort_dir = null;
        this.columns[param].sort = false;
      }
      this.filters.sort_col = this.sort_col;
      this.filters.sort_dir = this.sort_dir;
      this.applyFilters();
    },
    sort_profile() {
      this.sort_col = "profile";
      if (this.columns["profile"].sort == false) {
        this.sort_dir = "ASC";
        this.dataList.sort((a, b) =>
          a.profile.name > b.profile.name
            ? 1
            : b.profile.name > a.profile.name
            ? -1
            : 0,
        );
        this.columns["profile"].sort = 1;
      } else if (this.columns[param].sort == 1) {
        this.sort_dir = "DESC";
        this.dataList.sort((a, b) =>
          a.profile.name < b.profile.name
            ? 1
            : b.profile.name < a.profile.name
            ? -1
            : 0,
        );
        this.columns["profile"].sort = -1;
      } else {
        this.columns["profile"].sort = false;
        this.applyFilters();
      }
    },

    async view_details(account) {
      this.selectedData = account;
      this.showDetails = true;
      await nextTick();

      var modalElement = document.getElementById("account-details");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalInstance.show();
    },
    async applyFilters() {
      this.loading = true;
      var requestString = "accounts?filters=1";
      if (this.filters.page != "")
        requestString += `&page=${this.filters.page}`;
      if (this.filters.rows != "")
        requestString += `&rows=${this.filters.rows}`;
      if (this.filters.id != "") requestString += `&id=${this.filters.id}`;
      if (this.filters.serial_number != "")
        requestString += `&serial_number=${this.filters.serial_number}`;
      if (this.filters.first_name != "")
        requestString += `&first_name=${this.filters.first_name}`;
      if (this.filters.last_name != "")
        requestString += `&last_name=${this.filters.last_name}`;
      if (this.filters.username != "")
        requestString += `&username=${this.filters.username}`;
      if (this.filters.profile != "")
        requestString += `&profile=${this.filters.profile}`;
      if (this.filters.next_profile != "")
        requestString += `&next_profile=${this.filters.next_profile}`;
      if (this.filters.phone != "")
        requestString += `&phone=${this.filters.phone}`;
      if (this.filters.phone_line != "")
        requestString += `&phone_line=${this.filters.phone_line}`;
      if (this.filters.address != "" && this.filters.address)
        requestString += `&address=${this.filters.address}`;
      if (this.filters.notes != "" && this.filters.notes)
        requestString += `&notes=${this.filters.notes}`;
      if (this.filters.ip_address != "")
        requestString += `&ip_address=${this.filters.ip_address}`;
      if (this.filters.expires_at != "")
        requestString += `&expires_at=${this.filters.expires_at}`;
      if (this.filters.auto_renew != "")
        requestString += `&auto_renew=${this.filters.auto_renew}`;
      if (this.filters.allowed_sessions != "")
        requestString += `&allowed_sessions=${this.filters.allowed_sessions}`;
      if (this.filters.active != "")
        requestString += `&active=${this.filters.active}`;
      if (this.filters.online != "")
        requestString += `&online=${this.filters.online}`;
      if (this.filters.created_at != "" && this.filters.created_at != undefined)
        requestString += `&created_at=${this.filters.created_at}`;
      if (this.filters.reseller_id != "" && this.filters.reseller_id != null)
        requestString += `&reseller_id=${this.filters.reseller_id}`;
      if (this.filters.search_query != null)
        requestString += `&search_query=${this.filters.search_query}`;
      if (this.filters.search_query_full != null)
        requestString += `&search_query=${this.filters.search_query_full}`;
      if (this.filters.paid_at != "" && this.filters.paid_at != undefined)
        requestString += `&paid_at=${this.filters.paid_at}`;
      if (this.sort_col)
        requestString += `&order_by=${this.sort_col}&order_dir=${this.sort_dir}`;
      if (this.in_debt) requestString += `&in_debt=true`;
      if (this.debounce != null) {
        this.debounce_counter++;
      } else {
        this.debounce_counter--;
      }
      var local_debounce_location = this.debounce_counter;
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(async () => {
      //   const response = await axios.get(requestString);
      //   if (local_debounce_location == this.debounce_counter) {
      //     this.dataList = Object.values(response.data.data);
      //     if (this.filters.save)
      //       localStorage.setItem(
      //         "accounts_filters",
      //         JSON.stringify(this.filters)
      //       );
      //     if (this.dataList.length < 1 && this.filters.page != 1) {
      //       this.filters.page = 1;
      //       this.applyFilters();
      //     }
      //     if (this.sort_col) {
      //       if (this.sort_dir == "ASC") {
      //         this.dataList.sort((a, b) =>
      //           a[this.sort_col] > b[this.sort_col]
      //             ? 1
      //             : b[this.sort_col] > a[this.sort_col]
      //             ? -1
      //             : 0
      //         );
      //       } else {
      //         this.dataList.sort((a, b) =>
      //           a[this.sort_col] < b[this.sort_col]
      //             ? 1
      //             : b[this.sort_col] < a[this.sort_col]
      //             ? -1
      //             : 0
      //         );
      //       }
      //     }
      //     if (this.sort_col == "profile") {
      //       this.sort_profile();
      //     }
      //     this.meta = response.data.meta;
      //     this.loading = false;
      //   }
      // }, 1000);
      const response = await axios.get(requestString);
      if (local_debounce_location == this.debounce_counter) {
        this.dataList = Object.values(response.data.data);
        if (this.filters.save)
          localStorage.setItem(
            "accounts_filters",
            JSON.stringify(this.filters),
          );
        if (this.dataList.length < 1 && this.filters.page != 1) {
          this.filters.page = 1;
          this.applyFilters();
        }
        if (this.sort_col) {
          if (this.sort_dir == "ASC") {
            this.dataList.sort((a, b) =>
              a[this.sort_col] > b[this.sort_col]
                ? 1
                : b[this.sort_col] > a[this.sort_col]
                ? -1
                : 0,
            );
          } else {
            this.dataList.sort((a, b) =>
              a[this.sort_col] < b[this.sort_col]
                ? 1
                : b[this.sort_col] < a[this.sort_col]
                ? -1
                : 0,
            );
          }
        }
        if (this.sort_col == "profile") {
          this.sort_profile();
        }
        this.meta = response.data.meta;
        this.loading = false;
      }
    },
    async fetchResellers() {
      const response = await axios.get(
        "admins?filter=1&type=resellers&rows=10000&itr=true",
      );
      if (response.status == 200) this.resellers = response.data.data;
    },
    async fetchDataPortion(rows, currentPage) {
      this.filters.rows = rows;
      this.filters.page = currentPage;
      this.applyFilters();
    },
    async editData(account, tab = "same") {
      if (tab == "same") this.$router.push(`/accounts/${account.id}/edit`);
      else this.openInNewTab(`/accounts/${account.id}/edit`);
    },
    async renewTemp(account) {
      this.$swal({
        title: this.$t("accounts.add_2_temp_days") + " " + account.username,
        text: this.$t("accounts.this_will_add_2_temp_days_to_the_subscription"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_add_2_days"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-primary",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(
              `accounts/${account.id}/renew/temp`,
            );
            if (response.status == 200) {
              console.log("success");
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("accounts.two_temp_days_added_to_the_subscription"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async renew72(account) {
      this.$swal({
        title: this.$t("accounts.add_3_temp_days") + " " + account.username,
        text: this.$t("accounts.this_will_add_3_temp_days_to_the_subscription"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_add_3_days"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-primary",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(
              `accounts/${account.id}/renew/72`,
            );
            if (response.status == 200) {
              console.log("success");
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t(
                "accounts.three_temp_days_added_to_the_subscription",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async renewTempFree(account) {
      this.$swal({
        title: this.$t("accounts.add_2_free_days") + " " + account.username,
        text: this.$t("accounts.this_will_add_2_free_days_to_the_subscription"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_add_2_days"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-primary",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(
              `accounts/${account.id}/renew/temp/free`,
            );
            if (response.status == 200) {
              console.log("success");
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("accounts.two_free_days_added_to_the_subscription"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    successRenew(bill) {
      this.showRenew = false;
      this.selectedBill = bill;
      this.applyFilters();
      this.$swal({
        title: this.$t("accounts.renew"),
        text: this.$t("accounts.account_has_been_renewed_successfully"),
        icon: "success",
        confirmButtonText: this.$t("accounts.print_bill"),
        cancelButtonText: this.$t("accounts.close"),
        buttonsStyling: false,
        showCancelButton: true,
        backdrop: true,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-label-success",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.printBill(bill);
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async speedTemp(account) {
      this.selectedData = account;
      this.showTempSpeed = true;
    },
    openInNewTab(url) {
      window.open(url, "_blank").focus();
    },
    async editProfile(account) {
      this.$router.push(`/profiles/${account.profile.id}/edit`);
      this.$store.commit("changeKey");
    },
    async renewData(account) {
      this.selectedData = account;
      this.showRenew = true;
      await nextTick();
      var modalElement = document.getElementById("renew-account-profile");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showRenew = false;
      });
      modalInstance.show();
    },
    async clearData(account) {
      this.$swal({
        title:
          this.$t("accounts.delete_account_sessions") + " " + account.username,
        text: this.$t(
          "accounts.this_will_delete_all_account_sessions_and_reset_quota_usage",
        ),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_clear_sessions"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(`/accounts/${account.id}/clear`);
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("accounts.account_sessions_have_been_cleared"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });

      this.loading_overlay = false;
    },
    async deleteData(account) {
      this.$swal({
        title:
          this.$t("accounts.delete_account_permanently") +
          " " +
          account.username,
        text: this.$t("accounts.this_will_delete_account_permanently"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(`accounts/${account.id}`);
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t(
                "accounts.the_account_has_been_permanently_deleted",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });

      this.loading_overlay = false;
    },
    async disableData(account) {
      this.$swal({
        title: this.$t("control.are_you_sure") + " " + account.username,
        text: this.$t("accounts.this_will_deactivate_account_temporarily"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_deactivate"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-warning",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(`accounts/${account.id}/disable`);
            if (response.status == 200) {
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("accounts.deactivated"),
              text: this.$t("accounts.the_account_has_been_deactivated"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async enableData(account) {
      this.$swal({
        title: this.$t("control.are_you_sure") + " " + account.username,
        text: this.$t("accounts.this_will_reactivate_account"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_activate"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-warning",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(`accounts/${account.id}/disable`);
            if (response.status == 200) {
              console.log("success");
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("accounts.activated"),
              text: this.$t("accounts.account_has_been_reactivated"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async disconnectData(account) {
      this.$swal({
        title: this.$t("control.are_you_sure") + " " + account.username,
        text: this.$t(
          "accounts.this_will_disconnect_the_user_from_the_internet",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_disconnect"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.put(
              `accounts/${account.id}/disconnect`,
            );
            if (response.status == 200) {
              console.log("success");
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.disconnect"),
              text: this.$t(
                "accounts.the_user_has_been_disconnected_from_the_internet",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupDelete() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "accounts.this_will_delete_all_selected_accounts_permanently",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`accounts/group`, {
              accounts: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t("accounts.selected_accounts_has_been_deleted"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupDisable() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("accounts.this_will_disable_all_selected_accounts"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_deactivate"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`accounts/group/disable`, {
              accounts: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("accounts.deactivated"),
              text: this.$t("accounts.selected_accounts_has_been_disabled"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupEnable() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("accounts.this_will_enable_all_selected_accounts"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_enable"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-success",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`accounts/group/disable`, {
              accounts: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("accounts.enabled"),
              text: this.$t("accounts.selected_accounts_has_been_enabled"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupDisconnect() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t("accounts.this_will_disconnect_all_selected_accounts"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_disconnect"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`accounts/group/disconnect`, {
              accounts: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.disconnect"),
              text: this.$t("accounts.selected_accounts_has_been_disconnected"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupRenew48() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "accounts.this_will_add_48h_temporarily_to_all_selected_accounts",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_add_2_days"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`accounts/grouprenew/temp`, {
              accounts: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("accounts.added_temp_48h_to_selected_accounts"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupRenew72() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "accounts.this_will_add_72h_temporarily_to_all_selected_accounts",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_add_3_days"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`accounts/grouprenew/72`, {
              accounts: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("accounts.added_temp_72h_to_selected_accounts"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupRenew48Free() {
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "accounts.this_will_add_free_48h_to_all_selected_accounts",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_add_2_days"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`accounts/grouprenew/free`, {
              accounts: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("accounts.added_free_48h_to_selected_accounts"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async groupClear() {
      this.loading_overlay = true;
      this.$swal({
        title: this.$t("control.are_you_sure"),
        text: this.$t(
          "accounts.this_will_delete_all_selected_accounts_sessions_permanently",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("accounts.yes_clear_sessions"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`accounts/group/clear`, {
              accounts: this.selection_array,
            });
            if (response.status == 200) {
              this.selection_array = [];
              this.applyFilters();
            }
            this.$swal({
              title: this.$t("control.delete"),
              text: this.$t(
                "accounts.selected_accounts_sessions_has_been_deleted",
              ),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });

      this.loading_overlay = false;
    },
    async groupEditExpiration() {
      this.$swal
        .fire({
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("control.yes"),
          cancelButtonText: this.$t("control.no"),
          reverseButtons: true,
          backdrop: true,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-label-warning",
            cancelButton: "btn btn-label-secondary",
          },
          title: this.$t("accounts.edit_accounts_expirations"),
          html: `
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-calendar-time"></i>
                </div>
                <input
                  id="swal-input1"
                  v-model="date"
                  type="datetime-local"
                  class="form-control"
                  placeholder="YYYY-MM-DD HH:MM"
                />
              </div>
            `,
          preConfirm: () => {
            return new Promise((resolve) => {
              resolve([document.getElementById("swal-input1").value]);
            });
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const new_date = result.value[0];
            try {
              const response = await axios.post(`accounts/group/expiration`, {
                expires_at: moment(new_date).format("yyyy-MM-DD HH:mm"),
                accounts: this.selection_array,
              });
              if (response.status == 200) {
                this.$swal({
                  icon: "success",
                  title: this.$t("accounts.accounts_expiration_updated"),
                  timer: 1500,
                  showConfirmButton: false,
                });
                this.selection_array = [];
                this.applyFilters();
              }
            } catch (error) {
              this.$swal({
                icon: "error",
                title: "Update Failed",
                text: "An error occurred. Please try again.",
                confirmButtonText: this.$t("control.ok"),
              });
            }
          }
        });
    },
    async groupEditProfile() {
      const response = await axios.get(
        "/profiles?itr=1&type=subscribtion&rows=1000000",
      );
      var profiles_options = "";
      if (response.status == 200) {
        var profiles = response.data.data;
        profiles.forEach((element) => {
          profiles_options += `<option value="${element.id}">${element.name}</option>`;
        });
      }
      this.$swal
        .fire({
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("control.yes"),
          cancelButtonText: this.$t("control.no"),
          reverseButtons: true,
          backdrop: true,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-label-warning",
            cancelButton: "btn btn-label-secondary",
          },
          title: this.$t("accounts.edit_accounts_profiles"),
          html: `
              <div class="input-group">
                <div class="input-group-text">
                  <i class="ti ti-calendar-time"></i>
                </div>
                <select
                  id="swal-input1"
                  class="form-select">
                ${profiles_options}
                </select>
              </div>
            `,
          preConfirm: () => {
            return new Promise((resolve) => {
              resolve([document.getElementById("swal-input1").value]);
            });
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const new_profile_id = result.value[0];
            try {
              const response = await axios.post(`accounts/group/profile`, {
                profile_id: new_profile_id,
                accounts: this.selection_array,
              });
              if (response.status == 200) {
                this.$swal({
                  icon: "success",
                  title: this.$t("accounts.accounts_profiles_updated"),
                  timer: 1500,
                  showConfirmButton: false,
                });
                this.selection_array = [];
                this.applyFilters();
              }
            } catch (error) {
              this.$swal({
                icon: "error",
                title: "Update Failed",
                text: "An error occurred. Please try again.",
                confirmButtonText: this.$t("control.ok"),
              });
            }
          }
        });
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    formatDateHours(date) {
      //todo fix UTC BUG
      if (date == "never" || date == "" || date == null) return "N/A";
      return moment(date).format("DD-MM-YYYY hh:mm");
    },
    formatTraffic(octets) {
      const bytes = octets; // 1 octet = 1 byte
      const units = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      let value = bytes;

      while (value >= 1024 && i < units.length - 1) {
        value /= 1024;
        i++;
      }

      return `${value.toFixed(1)} ${units[i]}`;
    },
    openContextMenu(e, data) {
      this.selectedData = data;
      this.$refs.menu.open(e);
    },
    checkAll() {
      if (this.allSelected) {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = false;
        });
        this.allSelected = false;
      } else {
        this.selection_array = [];
        this.dataList.forEach((element) => {
          element.selected = true;
          this.selection_array.push(element);
        });
        this.allSelected = true;
      }
    },
    selectData(data) {
      if (data.selected == false) {
        data.selected = true;
        this.selection_array.push(data);
      } else {
        data.selected = false;
        this.selection_array.splice(this.selection_array.indexOf(data), 1);
      }
    },
    async toggleAutoUpdate() {
      this.autoUpdate = !this.autoUpdate;
      while (this.autoUpdate) {
        this.applyFilters();
        await new Promise((r) => setTimeout(r, 30000));
      }
    },
    async openAddProfileDialog(profile = null) {
      this.showAddProfile = true;
      if (profile) {
        this.$router.push({
          query: { profile_id: profile.id },
        });
      }
      await this.$nextTick();
      var modalElement = document.getElementById("add-profile");
      var modalInstance = new bootstrap.Modal(modalElement);
      modalElement.addEventListener("hide.bs.modal", (event) => {
        this.showAddProfile = false;
        this.$router.push({ query: {} });
      });
      modalInstance.show();
    },
    percentColor(card) {
      var percent = parseFloat(
        (card.used_quota_mb * 100) / card.allowed_quota_mb,
      ).toFixed(0);
      if (percent > 0 && percent <= 49) return "#009BFF";
      else if (percent > 49 && percent <= 74) return "#fcba35";
      else if (percent > 74 && percent < 100) return "#ff2626";
      else return "#000000";
    },
    async printBill(bill) {
      this.selectedBill = bill;
      await this.$nextTick();
      await this.print_element("bill_print_page");
    },
    exportCsv() {
      window.location.href =
        localStorage.getItem("server_api") + `accounts/export`;
    },
    export_csv(table_id, file_name) {
      return export_csv(table_id, file_name);
    },
    export_pdf(table_id, file_name) {
      return export_pdf(table_id, file_name);
    },
    print_table(id) {
      print_table(id);
    },
    print_element(id) {
      print_element(id);
    },
    toggleSaveFilters() {
      this.filters.save = !this.filters.save;
      localStorage.setItem("accounts_filters", JSON.stringify(this.filters));
    },
    openTab(url) {
      window.open(url, "_blank");
    },
    updateColumns() {
      localStorage.setItem(
        "accounts2_columns",
        JSON.stringify(Object.values(this.columns)),
      );
    },
  },
};
</script>
<style scoped>
.sortable {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sortable:hover .arrow-up,
.sortable:hover .arrow-down {
  color: #ccc; /* Slightly darker on hover */
}

.column-title {
  text-transform: uppercase;
  color: #333; /* Dark text color */
}

.sort-arrows {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}

.arrow-up,
.arrow-down {
  display: block;
  line-height: 1;
  color: transparent; /* Default gray color for inactive arrows */
  transition: color 0.2s ease;
}

.sortable[data-sort="asc"] .arrow-up {
  color: #666; /* Darker color for active ascending arrow */
}

.sortable[data-sort="desc"] .arrow-down {
  color: #666; /* Darker color for active descending arrow */
}
</style>
